//export const baseUrl = 'http://localhost:5000';
export const baseUrl = 'https://socialnetworkapi.ahmohazzab.com';